import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, TermFilter, NoticeStatusOptions, NoticeReceipentTypeOptions, FilterOptions, StudentReceipentTypeOptions } from "../../../../../../_helpers/Helpers";
import { usePrivateNoticesUIContext } from "../PrivateNoticesUIContext";

const prepareFilter = (queryParams, values) => {
  const { term, sender, definition, explanation, createDate, receipentType, isSent } = values;
  const newQueryParams = { ...queryParams };
  const filter = { sender, definition, explanation, createDate, receipentType, isSent };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function PrivateNoticesFilter() {
  // Private Notices UI Context
  const privateNoticesUIContext = usePrivateNoticesUIContext();
  const privateNoticesUIProps = useMemo(() => {
    return {
      setQueryParams: privateNoticesUIContext.setQueryParams,
      queryParams: privateNoticesUIContext.queryParams,
    };
  }, [privateNoticesUIContext]);
  
  const { currentActiveTerm } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm
    }),
    shallowEqual
  );

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(privateNoticesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, privateNoticesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      privateNoticesUIProps.setQueryParams(newQueryParams);
    }
  };

  const receipentTypeOptions = FilterOptions.concat(NoticeReceipentTypeOptions.slice(0, 5)).concat(StudentReceipentTypeOptions.slice(2, 5));
  
  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        sender: "",
        definition: "",
        explanation: "",
        createDate: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="sender"
                placeholder="Gönderen"
                onBlur={handleBlur}
                value={values.sender}
                onChange={(e) => {
                  setFieldValue("sender", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Gönderen</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="definition"
                placeholder="Tanımı"
                onBlur={handleBlur}
                value={values.definition}
                onChange={(e) => {
                  setFieldValue("definition", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Tanımı</b>
              </small>
            </div>            
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="explanation"
                placeholder="Açıklaması"
                onBlur={handleBlur}
                value={values.explanation}
                onChange={(e) => {
                  setFieldValue("explanation", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Açıklaması</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="createDate"
                placeholder="Tarih"
                onBlur={handleBlur}
                value={values.createDate}
                onChange={(e) => {
                  setFieldValue("createDate", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Tarih</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={receipentTypeOptions}
                value={values.receipentType}
                placeholder="Gönderim Grubu"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("receipentType", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Gönderim Grubu</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={NoticeStatusOptions}
                value={values.isSent}
                placeholder="Durum"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("isSent", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Durum</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}